import { render, staticRenderFns } from "./myaddQuestionnaire.vue?vue&type=template&id=a016894e&scoped=true&"
import script from "./myaddQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./myaddQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./myaddQuestionnaire.vue?vue&type=style&index=0&id=a016894e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a016894e",
  null
  
)

export default component.exports